<template>
  <div
    class="round-button"
    @click="onClick()"
  >
    <i :class="icon" />
  </div>
</template>
<script>
export default {
  name: "RoundButton",
  props: {
    icon: {
      type: String,
      default: "icon-add",
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/round-button";
</style>